module.exports = __webpack_public_path__ + "img/2-sm.fff38f15.jpg";